import { API_URL } from "constants/index";
import { fetchWithAuth } from "./fetch-with-auth";

const TASKS_URL = `${API_URL}/tasks/all`;

export const fetchTasksFromAPI = async (session: any) => {
  try {
    const response = await fetchWithAuth(TASKS_URL, { method: 'GET' }, session);

    if (!response.ok) {
      throw new Error(`Failed to fetch tasks: ${response.statusText}`);
    }

    const tasks = await response.json();
    return tasks;
  } catch (error) {
    console.error(error);
    throw error;  
  }
};
